var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.20369 1.32132L0.382019 5.14549C0.238552 5.30416 0.161597 5.51193 0.167088 5.72577C0.172579 5.93962 0.260096 6.14316 0.411517 6.29426C0.562939 6.44536 0.766668 6.53245 0.980525 6.53748C1.19438 6.54252 1.40198 6.46512 1.56035 6.32132L5.38202 2.49965C5.53829 2.34343 5.75022 2.25567 5.97119 2.25567C6.19216 2.25567 6.40408 2.34343 6.56035 2.49965L10.382 6.32132C10.5384 6.47758 10.7504 6.56532 10.9715 6.56524C11.1925 6.56516 11.4045 6.47727 11.5608 6.3209C11.717 6.16454 11.8048 5.9525 11.8047 5.73144C11.8046 5.51038 11.7167 5.29841 11.5604 5.14215L7.73869 1.32132C7.26987 0.852643 6.6341 0.589355 5.97119 0.589355C5.30828 0.589355 4.6725 0.852643 4.20369 1.32132V1.32132Z",
    fill: "#5C5F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4c05563a1f3061691487223a2a367874.svg";
export { ForwardRef as ReactComponent };